import endpoints from "../constants/env/middletier";

import React, {useEffect, useRef, useState} from 'react';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { Tooltip } from 'primereact/tooltip';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { InputText } from "primereact/inputtext";
import {useAuth} from "../AuthProvider";

export default function LogsPage() {
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const [cxProjects, setCxProjects] = useState(null);
    const [logs, setLogs] = useState(null);
    const [logLookup, setLogLookup] = useState(null);
    const [selectedLog, setSelectedLog] = useState(null);
    const [visible, setVisible] = useState(false);
    const [filters, setFilters] = useState({
        logType: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [logTypes] = useState(['ISSUE', 'ERROR', 'SUMMARY']);
    const { keycloak } = useAuth()

    const sortByCreatedAt = (a, b) => b.createdAt.localeCompare(a.createdAt);

    const fetchLogLookup = async () => {
        try {
            await keycloak.updateToken(30);

            // const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
            // // const logResponse = await fetch(Endpoints["ingestionloglookup"], {
            //     method: "GET"
            // });

            const logResponse = await fetch(`${endpoints.ingestionloglookup}`, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });


            if (!logResponse.ok) {
                throw new Error("Loglookup: Bad response");
            }

            const logLookupData = await logResponse.json();

            const sortedLookup = [...logLookupData].sort(sortByCreatedAt);

            setLogLookup(sortedLookup);
        } catch (error) {
            console.error("Failed to fetch log lookup:", error);
        }
    };

    useEffect(() => {
        fetchLogLookup();
    }, []);

    const getSeverity = (status) => {
        switch (status) {
            case 'ERROR':
                return 'danger';

            case 'SUMMARY':
                return 'success';

            case 'ISSUE':
                return 'info';
        }
    };
    const logTypeItemTemplate = (option) => {
        return <Tag value={option} severity={getSeverity(option)} />;
    };

    const logTypeRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={logTypes}
                      onChange={(e) => options.filterApplyCallback(e.value)}
                      itemTemplate={logTypeItemTemplate} placeholder="Select Type Filter"
                      className="p-column-filter" showClear style={{ minWidth: '12rem' }} />
        );
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.logType} severity={getSeverity(rowData.logType)} />;
    };

    const handleLogSelection = async (e) => {
        console.log(e.value);
        e.preventDefault();

        setSelectedLog(e.value);

        await keycloak.updateToken(30);

        // Retrieve the logs from the recent upload
        // const logResponse = await fetch(`${endpoints.ingestionlog}${e.value}`, {
        // // const logResponse = await fetch(Endpoints["ingestionlog"] + e.value, {
        //     method: "GET"
        // });

        const logResponse = await fetch(`${endpoints.ingestionlog}${e.value}`, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
        });

        if (!logResponse.ok) {
            throw new Error("Logs: Bad response");
        }

        const logData = await logResponse.json();
        setLogs(logData);




        // try {
        //     const response = await fetch(Endpoints["project"], {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify(project),
        //     });
        //
        //     const result = await response.json();
        //     console.log("Success:", result);
        //
        //     clearFormValues();
        // } catch (error) {
        //     console.error("Error submitting form:", error);
        // } finally {
        //     setLoading(false);
        // }
    };




    return (
        <>
            {logLookup && (
                <div>
                    <Dropdown value={selectedLog} onChange={handleLogSelection}
                              options={logLookup} optionLabel="ingestionProjectDescription" optionValue="ingestionRunId"
                              placeholder="Select a Log" className="w-full md:w-16rem" />
                    <br />
                    <br />
                </div>
            )}

            {logs && (
                <div className="card">
                    <DataTable value={logs} tableStyle={{ minWidth: '50rem' }} filters={filters} filterDisplay="row">
                        <Column field="logType" header="Log Type" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                style={{ minWidth: '12rem' }} filter filterElement={logTypeRowFilterTemplate} body={statusBodyTemplate} />
                        <Column field="logEntity" header="Entity"></Column>
                        <Column field="logContent" header="Log Data"></Column>
                        </DataTable>
                    <br />
                    <br />
                    <br />
                </div>
            )}
        </>

    )
}
